import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaArrowRight, FaDownload } from 'react-icons/fa';
import { fetchProgrammeBook } from '../../config';
import './ProgramHighlight.css';

const ProgramHighlight = () => {
  const [programmeBook, setProgrammeBook] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchProgrammeBook().then((book) => { if (!cancelled) setProgrammeBook(book); });
    return () => { cancelled = true; };
  }, []);

  return (
    <section className="program-highlight fade-in-up">
      <div className="container">
        <div className="program-highlight-card">
          <div className="program-highlight-icon">
            <FaCalendarAlt />
          </div>
          <div className="program-highlight-text">
            <h2 className="program-highlight-title">Conference Program Now Available</h2>
            <p className="program-highlight-desc">
              Get an overview of what will happen across the conference, day by day, together
              with the delegate master timetable for 1&ndash;4 December 2026.
            </p>
          </div>
          <div className="program-highlight-actions">
            <Link to="/information/program" className="program-highlight-cta">
              View the Program <FaArrowRight className="program-highlight-cta-icon" />
            </Link>
            {programmeBook && (
              <a href={programmeBook.downloadUrl} download className="program-highlight-cta program-highlight-cta--secondary">
                <FaDownload className="program-highlight-cta-icon" /> Programme Book
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramHighlight;
